<template>
  <div>
    <b-modal
        v-model="showModalInternal"
        id="category-select-modal-form"
        scrollable
        title="Baza kategorii"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer
    >
      <div v-if="showModalInternal">

        <ParentProductCategoriesDataList
            ref="categoriesDataList"
            :multiselect="multiselect"
            @applyItemsInSelectMode="applySelectCategories"
            :showRowActions="showRowActions"
            :showMassActions="showMassActions"
            :selectedCategoriesData="selectedCategoriesData"
            :showAddButton="showAddButton"
            :disableInitiallyCheckedItems="true"
            :categoryGuidForWhichWeSelectParent="categoryGuidForWhichWeSelectParent"
        >
        </ParentProductCategoriesDataList>


      </div>


    </b-modal>
  </div>
</template>
<script>
import {defineComponent} from 'vue'
import {BModal} from 'bootstrap-vue-next'
import ParentProductCategoriesDataList from "@/views/DrugstoreCommonManager/ParentProductCategoriesDataList.vue";
export default defineComponent({
  name: 'ParentProductCategoriesListModal',// we need this to avoid circular reference when selecting parent category for another category
  props: {
    showModal: { type: Boolean, required: true },
    multiselect: { type: Boolean, default: true },
    showMassActions: { type: Boolean, default: () => true },
    showRowActions: { type: Boolean, default: () => true },
    showAddButton: { type: Boolean, default: () => true },
    selectedCategoriesData: { type: Array, default: () => [] },
    okTitle: { type: String, default: 'Wybierz' },
    resetSelectionAfterApply: { type: Boolean, default: () => false },
    categoryGuidForWhichWeSelectParent: { type: String, required: false},
  },
  emits: ['update:showModal','onApply','onClose'],
  components: {ParentProductCategoriesDataList, BModal},
  data(){
    return {
      showModalInternal: this.showModal
    }
  },
  methods:{
    applySelectCategories(categories){
      console.log("Selected categories:",categories)

      this.$emit('onApply',categories)
    },
    closeModal(){
      this.showModalInternal = false
      this.$emit('onClose')
    }
  },
  watch:{
    showModal(newValue){
      this.showModalInternal = newValue
    },
    showModalInternal(newValue){
      this.$emit('update:showModal', newValue)
    }
  }
})
</script>
<style scoped>
.modal-footer-container {
  position: sticky;
  bottom: -19px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 60;
  padding: 0;
}

.modal-footer-bottom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px;
}
</style>